<template lang="html">
  <div class="footer-wrapper">
    <div class="page-help upper-wrapper">
      <div class="newsletter-wrapper">
        <img
          src="@/assets/newImges/new-logo.png"
          alt="logo image"
          class="logo"
        />
        <div class="description">{{ $t("footer.newsletter.description") }}</div>
        <div class="socials">
          <!-- href="https://www.linkedin.com/in/eberza-afeja-ltd-a72496231/" -->
          <a
            href="https://www.linkedin.com/company/eberza-afeja-ltd/"
            target="_blank"
          >
            <img src="@/assets/icons/linkedIn.svg" alt="linkedIn logo" />
          </a>
          <a href="https://www.instagram.com/eberza.rs/" target="_blank">
            <img src="@/assets/icons/instagram.svg" alt="instagram logo" />
          </a>
          <a href="https://www.facebook.com/eberza.rs" target="_blank">
            <img src="@/assets/icons/facebook-yellow.svg" alt="facebook logo" />
          </a>
        </div>
      </div>
      <!-- end newsletter-wrapper -->
      <div class="contact-wrapper">
        <div class="contact-header">
          <span>{{ $t("footer.contact.header") }}</span>
        </div>
        <div class="contact-info-wrapper">
          <div class="contact-info">
            <div class="info">
              {{ $t("footer.contact.pin") }}
            </div>
          </div>
          <div class="contact-info">
            <div class="info">
              <a href="mailto:eberza@afeja.com">
                {{ $t("footer.contact.email") }}
              </a>
            </div>
          </div>
          <div class="contact-info">
            <div class="info">
              {{ $t("footer.contact.phone") }}
            </div>
          </div>
        </div>
      </div>
      <!-- end contact-wrapper -->
      <div class="navigation-wrapper">
        <div class="header">{{ $t("footer.links") }}</div>
        <div class="links-wrapper">
          <div class="links">
            <router-link :to="{ name: 'Berza', params: { lang: $i18n.locale } }"
              >eBerza</router-link
            >
            <router-link
              :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
              >{{ $t("nav.rules") }}</router-link
            >
            <!-- <router-link :to="{ name: 'Competitions', params: { lang: $i18n.locale } }">{{$t('nav.competitions')}}</router-link> -->

            <router-link
              :to="{ name: 'News', params: { lang: $i18n.locale } }"
              >{{ $t("nav.news") }}</router-link
            >
            <router-link
              :to="{ name: 'Faq', params: { lang: $i18n.locale } }"
              >{{ $t("nav.faq") }}</router-link
            >
            <router-link
              v-if="userName"
              :to="{ name: 'Profile', params: { lang: $i18n.locale } }"
              style="white-space: nowrap;"
              >{{ $t("nav.profile") }}
            </router-link>
            <!-- <router-link :to="{ name: 'About', params: { lang: $i18n.locale } }">{{$t('nav.sugestions')}}</router-link> -->
            <router-link
              v-if="userAdmin"
              :to="{ name: 'Admin', params: { lang: $i18n.locale } }"
              >Admin</router-link
            >
          </div>
        </div>
      </div>
      <!-- end contact-wrapper -->
    </div>
    <!-- end upper-wrapper -->

    <div class="page-help  lower-wrapper">
      <div v-html="$t('footer.intellectualProperty')" class="  rights"></div>
      <!-- <div class="terms-wrapper">
        <span>{{$t('footer.terms')}}</span>
        <span>{{$t('footer.privacy')}}</span>
      </div> -->
      <div class="line"></div>
      <div class="  rights">
        {{ $t("footer.rights") }}
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api";
import { mapState } from "vuex";

export default {
  name: "Footer",
  components: {},
  data() {
    return {};
  },
  methods: {},
  computed: {
    ...mapState(["userAdmin", "userName"])
  }
};
</script>

<style lang="scss" scoped>
.footer-wrapper {
  font-family: Outfit;
  box-sizing: border-box;
  margin-top: auto;
  // background-image: url('../assets/images/footerBackground.png');
  // background-size: cover;
  background: $gray-blue-100;
  min-height: 836px;
  display: flex;
  flex-direction: column;
  padding: 173px 0px 20px 0px;
  text-align: left;

  background-image: url("../assets/newImges/footer1.png"),
    url("../assets/newImges/footer2.png");
  background-position: left bottom, right top;
  background-repeat: no-repeat, no-repeat;
  background-size: contain, cover;

  .upper-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 60px;
    max-width: 1186px;

    .contact-wrapper {
      width: 458px;

      .contact-header {
        font-weight: 400;
        font-style: Regular;
        font-size: 28px;
        line-height: 30px;
        letter-spacing: 0%;
        margin-bottom: 48px;
      }
      .contact-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 15px;

        .info {
          font-weight: 400;
          font-style: Regular;
          font-size: 20px;
          line-height: 30px;
          letter-spacing: 0%;

          color: $blue-400;

          a {
            text-decoration: none;
            color: $blue-400;
          }
        }
      }
    }

    .newsletter-wrapper {
      max-width: 349px;
      .logo {
        width: 185px;
      }

      .description {
        font-weight: 400;
        font-style: Regular;
        font-size: 20px;
        line-height: 30px;
        letter-spacing: 0%;
        color: $blue-400;

        margin: 49px 0 42px 0;
      }
    }

    .navigation-wrapper {
      width: 100px;
      padding-left: 5%;
      display: flex;
      flex-direction: column;

      .header {
        font-weight: 400;
        font-style: Regular;
        font-size: 28px;
        line-height: 30px;
        letter-spacing: 0%;
        margin-bottom: 48px;
      }
      .links-wrapper {
        display: flex;
        flex-direction: row;

        .links {
          display: flex;
          flex-direction: column;
          align-items: flex-start;

          a {
            margin-bottom: 10px;
            text-decoration: none;
            color: $blue-400;

            font-weight: 400;
            font-style: Regular;
            font-size: 18px;
            line-height: 100%;
            letter-spacing: 0%;
          }
        }
        .links:first-child {
          margin-right: 80px;
        }
      }
    }
  }
  .rights {
    font-size: 12px;
    line-height: 20px;
    opacity: 0.8;
    margin-bottom: 10px;
    max-width: 1186px;
    width: 100%;
    align-self: center;
    span {
      opacity: 1;

      font-weight: 700;
    }
  }
  .lower-wrapper {
    margin-top: auto;
    height: 140px;

    justify-content: space-between;
    font-weight: 400;
    font-size: 12px;
    line-height: 30px;
    display: flex;
    flex-direction: column;
    color: $blue-400;

    .line {
      border-top: 1px solid $gray-blue-1300;
      margin: 40px 0;
    }

    .terms-wrapper {
      display: flex;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      min-width: 170px;
      cursor: pointer;
      white-space: nowrap;
      span {
        padding: 0 20px 0 0;
      }
      span:last-of-type {
        padding: 0 0 0 0 !important;
      }
    }
  }
}
.socials {
  width: 170px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  img {
    margin-left: 40px;
    cursor: pointer;
  }
}
@media only screen and (max-width: 1100px) {
  .footer-wrapper {
    padding: 60px 0px 40px 0px;

    .upper-wrapper {
      flex-direction: column;

      .contact-wrapper {
        width: 100%;
        max-width: 500px;
        margin: 0 auto 60px auto;
      }
      .newsletter-wrapper {
        width: 100%;
        max-width: 500px;
        margin: 0 auto 80px auto;

        .description {
          width: auto;
          margin: 0 auto 20px auto;
        }
      }
      .navigation-wrapper {
        width: 100%;
        max-width: 500px;
        margin: 0 auto 0px auto;
        padding-left: 0px;
      }
    }
  }
}
@media only screen and (max-width: 768px) {
  .footer-wrapper {
    .upper-wrapper {
      .links-wrapper {
        justify-content: space-between;
        flex-wrap: wrap;
        .links:first-child {
          margin-right: 0px !important;
        }
      }
    }
    .lower-wrapper {
      height: auto;
      flex-direction: column;

      div {
        margin: 20px auto 0px auto;
      }
      div:last-child {
        margin-bottom: 20px;
      }
    }
  }
}
.socials {
  justify-content: space-between;

  img:first-child {
    margin-left: 0px;
  }
}
</style>
